import Phaser from 'phaser'
import { GAME_WIDTH, GAME_HEIGHT } from './config'
import { GameScene } from './GameScene'

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameOverScene' })
  }

  create(data: { score: number; wave: number; won?: boolean }) {
    GameScene.clearSave()
    const cx = GAME_WIDTH / 2, cy = GAME_HEIGHT / 2
    const won = data.won || false

    this.add.rectangle(cx, cy, GAME_WIDTH, GAME_HEIGHT, 0x1a1a2e, 0.9)

    this.add.text(cx, 120, won ? '🎉 Victory! 🎉' : '💔 Resort Overrun 💔', {
      fontSize: '48px',
      fontFamily: 'Arial, sans-serif',
      color: won ? '#66BB6A' : '#ef5350',
      fontStyle: 'bold',
    }).setOrigin(0.5)

    this.add.text(cx, 200, `Survived ${data.wave || 1} waves`, {
      fontSize: '28px',
      fontFamily: 'Arial, sans-serif',
      color: '#ffffff',
    }).setOrigin(0.5)

    this.add.text(cx, 250, `🐟 ${data.score || 0} Fish Coins Earned`, {
      fontSize: '32px',
      fontFamily: 'Arial, sans-serif',
      color: '#64B5F6',
      fontStyle: 'bold',
    }).setOrigin(0.5)

    if (!won) {
      this.add.text(cx, 310, 'The snowmen got to the lodge...', {
        fontSize: '18px',
        fontFamily: 'Arial, sans-serif',
        color: '#B0BEC5',
        fontStyle: 'italic',
      }).setOrigin(0.5)
    }

    const btn = this.add.rectangle(cx, 410, 220, 55, 0x4CAF50).setInteractive({ useHandCursor: true })
    this.add.rectangle(cx, 410, 220, 55).setStrokeStyle(3, 0x388E3C)
    this.add.text(cx, 410, '🔄 Try Again', {
      fontSize: '26px',
      fontFamily: 'Arial, sans-serif',
      color: '#ffffff',
      fontStyle: 'bold',
    }).setOrigin(0.5)

    btn.on('pointerover', () => btn.setFillStyle(0x66BB6A))
    btn.on('pointerout', () => btn.setFillStyle(0x4CAF50))
    btn.on('pointerdown', () => this.scene.start('GameScene'))

    const menuBtn = this.add.rectangle(cx, 480, 220, 45, 0x5D4037).setInteractive({ useHandCursor: true })
    this.add.text(cx, 480, '🏠 Main Menu', {
      fontSize: '22px',
      fontFamily: 'Arial, sans-serif',
      color: '#ffffff',
    }).setOrigin(0.5)

    menuBtn.on('pointerover', () => menuBtn.setFillStyle(0x795548))
    menuBtn.on('pointerout', () => menuBtn.setFillStyle(0x5D4037))
    menuBtn.on('pointerdown', () => this.scene.start('BootScene'))
  }
}
